import { render, staticRenderFns } from "./healthTest.vue?vue&type=template&id=73ec8e06&scoped=true&"
import script from "./healthTest.vue?vue&type=script&lang=js&"
export * from "./healthTest.vue?vue&type=script&lang=js&"
import style0 from "./healthTest.vue?vue&type=style&index=0&id=73ec8e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ec8e06",
  null
  
)

export default component.exports